/**
 * Base API Service
 * 
 * This is the base class for all API services.
 * It provides common functionality like handling responses and errors.
 */

import { AxiosResponse } from 'axios';
import { Modal } from 'antd';
import { ApiResponse } from "../../../model";

export class ApiService {
  /**
   * Process API response and extract content data
   */
  protected processResponse<T>(response: AxiosResponse<ApiResponse<T>>): T | null {
    // Check if the response has the expected structure
    if (
      response.data &&
      typeof response.data === 'object' &&
      'content' in response.data
    ) {
      const { content } = response.data;
      return content;
    }
    
    return null;
  }
  
  /**
   * Handle API errors
   */
  protected handleError(error: any): null {
    let errorMessage = '系統發生錯誤';
    
    // If the error is from our API response handler
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    // If axios error
    else if (error.response) {
      const status = error.response.status;
      errorMessage = 
        error.response.data?.message || 
        `請求失敗 (${status})`;
    }
    // Generic error
    else {
      errorMessage = error.message || '未知錯誤';
    }
    
    // Display error message using antd Modal
    Modal.error({
      title: '錯誤',
      content: errorMessage
    });
    
    console.error('API Error:', error);
    return null;
  }
}
